/**
 * @purpose: Mengelola master setting report purchasing agar filter kategori memakai SubKategori TBMDPart lalu sub-kategori KodeItem.
 * @called_by: views/app_report/master_report_purchasing.html melalui ng-controller masterReportPurchasingCtrl.
 * @deps: AngularJS app, urlServices, toaster, API /api/report/purchase-category-options, API /api/report/purchase-history-settings.
 * @public: masterReportPurchasingCtrl.
 * @side_effects: Mengambil opsi kategori report dari server dan menyimpan settings report purchasing ke database.
 */
app.controller('masterReportPurchasingCtrl', function ($scope, urlServices, toaster) {
    $scope.modeOptions = [
        { value: 'rolling', label: 'Rolling' },
        { value: 'fixed', label: 'Fixed' }
    ];
    $scope.unitOptions = [
        { value: 'bulan', label: 'Bulan' },
        { value: 'semester', label: 'Semester (6 bulan)' },
        { value: 'tahun', label: 'Tahun' }
    ];

    $scope.categoryPanels = [
        {
            title: 'Kategori Purchase History',
            subKategoriKey: 'subKategoriValues',
            codeKey: 'categoryCodes'
        },
        {
            title: 'Kategori PURCHASE-KONTRIBUSI PEMBELIAN',
            subKategoriKey: 'contributionSubKategoriValues',
            codeKey: 'contributionCategoryCodes'
        },
        {
            title: 'Kategori Dashboard Purchasing',
            subKategoriKey: 'dashboardSubKategoriValues',
            codeKey: 'dashboardCategoryCodes'
        },
        {
            title: 'Kategori Trigger PO Entry / Purchase Reason Log',
            subKategoriKey: 'poReasonSubKategoriValues',
            codeKey: 'poReasonCategoryCodes'
        }
    ];
    $scope.availableCategoryGroups = [];
    $scope.data = {};
    $scope.isSaving = false;
    $scope.categoryKeywords = {};

    function sortSubKategoriValues(list) {
        var order = {
            BARANG: 1,
            JASA: 2
        };
        return (list || []).slice().sort(function (left, right) {
            var leftOrder = order[left] || 99;
            var rightOrder = order[right] || 99;
            if (leftOrder !== rightOrder) {
                return leftOrder - rightOrder;
            }
            return left > right ? 1 : -1;
        });
    }

    function normalizeSubKategoriValue(value) {
        var normalized = String(value || '').trim().toUpperCase();
        if (normalized === 'SERVICE') {
            normalized = 'JASA';
        }
        return normalized === 'BARANG' || normalized === 'JASA' ? normalized : '';
    }

    function normalizeSubKategoriValues(list) {
        var unique = {};
        if (!Array.isArray(list)) {
            return [];
        }
        list.forEach(function (value) {
            var normalized = normalizeSubKategoriValue(value);
            if (normalized) {
                unique[normalized] = true;
            }
        });
        return sortSubKategoriValues(Object.keys(unique));
    }

    function normalizeCategoryCodes(list) {
        var unique = {};
        if (!Array.isArray(list)) {
            return [];
        }
        list.forEach(function (value) {
            var normalized = String(value || '').trim().toUpperCase();
            if (normalized) {
                unique[normalized] = true;
            }
        });
        return Object.keys(unique).sort();
    }

    function ensureKeywordShape() {
        $scope.categoryPanels.forEach(function (panel) {
            $scope.categoryKeywords[panel.codeKey] = $scope.categoryKeywords[panel.codeKey] || '';
        });
    }

    function defaults() {
        return {
            subKategoriValues: [],
            categoryCodes: [],
            contributionSubKategoriValues: [],
            contributionCategoryCodes: [],
            dashboardSubKategoriValues: [],
            dashboardCategoryCodes: [],
            poReasonSubKategoriValues: [],
            poReasonCategoryCodes: [],
            priorityLabels: {
                p1: 'Prioritas 1',
                p2: 'Prioritas 2',
                p3: 'Prioritas 3',
                p4: 'Prioritas 4',
                special: 'Prioritas Khusus'
            },
            priorityDistribution: {
                p1: 20,
                p2: 30,
                p3: 30,
                p4: 20,
                specialNominal: 10000000
            },
            rankPeriod: {
                mode: 'rolling',
                unit: 'bulan',
                lookback: 12
            },
            previousPricePeriod: {
                mode: 'rolling',
                unit: 'bulan',
                lookback: 12
            }
        };
    }

    function buildAllowedCategoryMap(panel) {
        var allowedMap = {};
        var selectedSubKategori = $scope.data[panel.subKategoriKey] || [];

        if (!selectedSubKategori.length) {
            return allowedMap;
        }

        ($scope.availableCategoryGroups || []).forEach(function (group) {
            if (selectedSubKategori.indexOf(group.SubKategori) < 0) {
                return;
            }
            (group.items || []).forEach(function (item) {
                if (!allowedMap[item.KodeItem]) {
                    allowedMap[item.KodeItem] = {
                        KodeItem: item.KodeItem,
                        NamaItem: item.NamaItem
                    };
                }
            });
        });

        return allowedMap;
    }

    function syncPanelCategoryCodes(panel) {
        var allowedMap = buildAllowedCategoryMap(panel);
        var currentCodes = normalizeCategoryCodes($scope.data[panel.codeKey] || []);

        if (!Object.keys(allowedMap).length) {
            $scope.data[panel.codeKey] = [];
            return;
        }

        $scope.data[panel.codeKey] = currentCodes.filter(function (code) {
            return !!allowedMap[code];
        });
    }

    function syncLegacyCategorySelections() {
        if (!$scope.availableCategoryGroups.length) {
            return;
        }

        $scope.categoryPanels.forEach(function (panel) {
            var selectedSubKategori = normalizeSubKategoriValues($scope.data[panel.subKategoriKey] || []);
            var selectedCodes = normalizeCategoryCodes($scope.data[panel.codeKey] || []);

            if (!selectedSubKategori.length && selectedCodes.length) {
                var inferredSubKategori = {};
                $scope.availableCategoryGroups.forEach(function (group) {
                    (group.items || []).forEach(function (item) {
                        if (selectedCodes.indexOf(item.KodeItem) >= 0) {
                            inferredSubKategori[group.SubKategori] = true;
                        }
                    });
                });
                selectedSubKategori = sortSubKategoriValues(Object.keys(inferredSubKategori));
            }

            $scope.data[panel.subKategoriKey] = selectedSubKategori;
            $scope.data[panel.codeKey] = selectedCodes;

            if (selectedSubKategori.length) {
                syncPanelCategoryCodes(panel);
            }
        });
    }

    function ensureDataShape() {
        var d = $scope.data || {};
        d.priorityLabels = d.priorityLabels || {};
        d.priorityDistribution = d.priorityDistribution || {};
        d.rankPeriod = d.rankPeriod || {};
        d.previousPricePeriod = d.previousPricePeriod || {};
        d.subKategoriValues = normalizeSubKategoriValues(d.subKategoriValues || []);
        d.categoryCodes = normalizeCategoryCodes(d.categoryCodes || []);
        d.contributionSubKategoriValues = normalizeSubKategoriValues(d.contributionSubKategoriValues || d.subKategoriValues || []);
        d.contributionCategoryCodes = normalizeCategoryCodes(d.contributionCategoryCodes || d.categoryCodes || []);
        d.dashboardSubKategoriValues = normalizeSubKategoriValues(d.dashboardSubKategoriValues || d.subKategoriValues || []);
        d.dashboardCategoryCodes = normalizeCategoryCodes(d.dashboardCategoryCodes || d.categoryCodes || []);
        d.poReasonSubKategoriValues = normalizeSubKategoriValues(d.poReasonSubKategoriValues || d.subKategoriValues || []);
        d.poReasonCategoryCodes = normalizeCategoryCodes(d.poReasonCategoryCodes || d.categoryCodes || []);

        var def = defaults();
        d.priorityLabels.p1 = d.priorityLabels.p1 || def.priorityLabels.p1;
        d.priorityLabels.p2 = d.priorityLabels.p2 || def.priorityLabels.p2;
        d.priorityLabels.p3 = d.priorityLabels.p3 || def.priorityLabels.p3;
        d.priorityLabels.p4 = d.priorityLabels.p4 || def.priorityLabels.p4;
        d.priorityLabels.special = d.priorityLabels.special || def.priorityLabels.special;

        d.priorityDistribution.p1 = parseFloat(d.priorityDistribution.p1 || def.priorityDistribution.p1);
        d.priorityDistribution.p2 = parseFloat(d.priorityDistribution.p2 || def.priorityDistribution.p2);
        d.priorityDistribution.p3 = parseFloat(d.priorityDistribution.p3 || def.priorityDistribution.p3);
        d.priorityDistribution.p4 = parseFloat(d.priorityDistribution.p4 || def.priorityDistribution.p4);
        d.priorityDistribution.specialNominal = parseFloat(d.priorityDistribution.specialNominal || def.priorityDistribution.specialNominal);

        d.rankPeriod.mode = d.rankPeriod.mode || def.rankPeriod.mode;
        d.rankPeriod.unit = d.rankPeriod.unit || def.rankPeriod.unit;
        d.rankPeriod.lookback = parseInt(d.rankPeriod.lookback || def.rankPeriod.lookback, 10);

        d.previousPricePeriod.mode = d.previousPricePeriod.mode || def.previousPricePeriod.mode;
        d.previousPricePeriod.unit = d.previousPricePeriod.unit || def.previousPricePeriod.unit;
        d.previousPricePeriod.lookback = parseInt(d.previousPricePeriod.lookback || def.previousPricePeriod.lookback, 10);

        $scope.data = d;
        ensureKeywordShape();
        $scope.syncPriority4Distribution();
        syncLegacyCategorySelections();
    }

    $scope.toggleSubKategori = function (panel, value) {
        $scope.data[panel.subKategoriKey] = normalizeSubKategoriValues($scope.data[panel.subKategoriKey] || []);
        var idx = $scope.data[panel.subKategoriKey].indexOf(value);
        if (idx >= 0) {
            $scope.data[panel.subKategoriKey].splice(idx, 1);
        } else {
            $scope.data[panel.subKategoriKey].push(value);
        }
        $scope.data[panel.subKategoriKey] = sortSubKategoriValues($scope.data[panel.subKategoriKey]);
        syncPanelCategoryCodes(panel);
    };

    $scope.isSubKategoriSelected = function (key, value) {
        $scope.data[key] = $scope.data[key] || [];
        return $scope.data[key].indexOf(value) >= 0;
    };

    $scope.hasSelectedSubKategori = function (key) {
        $scope.data[key] = $scope.data[key] || [];
        return $scope.data[key].length > 0;
    };

    $scope.getAvailableSubCategories = function (panel) {
        var keyword = String($scope.categoryKeywords[panel.codeKey] || '').toLowerCase();
        var allowedMap = buildAllowedCategoryMap(panel);

        return Object.keys(allowedMap).sort().map(function (code) {
            return allowedMap[code];
        }).filter(function (item) {
            if (!keyword) {
                return true;
            }
            var kode = String(item.KodeItem || '').toLowerCase();
            var nama = String(item.NamaItem || '').toLowerCase();
            return kode.indexOf(keyword) >= 0 || nama.indexOf(keyword) >= 0;
        });
    };

    $scope.toggleCategory = function (panel, code) {
        var allowedMap = buildAllowedCategoryMap(panel);
        if (!allowedMap[code]) {
            return;
        }
        $scope.data[panel.codeKey] = normalizeCategoryCodes($scope.data[panel.codeKey] || []);
        var idx = $scope.data[panel.codeKey].indexOf(code);
        if (idx >= 0) {
            $scope.data[panel.codeKey].splice(idx, 1);
        } else {
            $scope.data[panel.codeKey].push(code);
            $scope.data[panel.codeKey] = normalizeCategoryCodes($scope.data[panel.codeKey]);
        }
    };

    $scope.isCategorySelected = function (key, code) {
        $scope.data[key] = $scope.data[key] || [];
        return $scope.data[key].indexOf(code) >= 0;
    };

    $scope.syncPriority4Distribution = function () {
        var dist = ($scope.data && $scope.data.priorityDistribution) ? $scope.data.priorityDistribution : {};
        var p1 = Math.max(0, parseFloat(dist.p1 || 0));
        var p2 = Math.max(0, parseFloat(dist.p2 || 0));
        var p3 = Math.max(0, parseFloat(dist.p3 || 0));
        var p4 = 100 - (p1 + p2 + p3);
        dist.p1 = p1;
        dist.p2 = p2;
        dist.p3 = p3;
        dist.p4 = p4 > 0 ? p4 : 0;
        $scope.data.priorityDistribution = dist;
    };

    $scope.resetDefault = function () {
        $scope.data = defaults();
        $scope.categoryKeywords = {};
        ensureDataShape();
    };

    $scope.loadCategory = function () {
        urlServices.ambilData('api/report/purchase-category-options', {}, function (err, sukses) {
            if (err) {
                toaster.pop('error', 'Error', 'Gagal mengambil kategori report purchasing');
                $scope.availableCategoryGroups = [];
                return;
            }
            var res = sukses.data ? sukses.data : sukses;
            $scope.availableCategoryGroups = res.groups || [];
            syncLegacyCategorySelections();
        });
    };

    $scope.loadSettings = function () {
        urlServices.ambilData('api/report/purchase-history-settings', {}, function (err, sukses) {
            if (err) {
                toaster.pop('error', 'Error', 'Gagal mengambil setting');
                $scope.data = defaults();
                ensureDataShape();
                return;
            }
            $scope.data = sukses.data ? sukses.data : sukses;
            ensureDataShape();
        });
    };

    $scope.saveSettings = function () {
        if ($scope.isSaving) {
            return;
        }
        ensureDataShape();
        $scope.syncPriority4Distribution();
        $scope.isSaving = true;
        var payload = {
            settings_json: JSON.stringify($scope.data)
        };
        urlServices.updateData('api/report/purchase-history-settings', payload, function (err) {
            $scope.isSaving = false;
            if (err) {
                var message = 'Gagal menyimpan setting';
                if (err && err.err) {
                    if (typeof err.err === 'string') {
                        message = err.err;
                    } else if (err.err.message) {
                        message = err.err.message;
                    }
                }
                toaster.pop('error', 'Error', message);
            } else {
                toaster.pop('success', 'Success', 'Setting berhasil disimpan');
                $scope.loadSettings();
            }
        });
    };

    $scope.loadCategory();
    $scope.loadSettings();

    $scope.$watchGroup([
        'data.priorityDistribution.p1',
        'data.priorityDistribution.p2',
        'data.priorityDistribution.p3',
        'data.priorityDistribution.specialNominal'
    ], function () {
        $scope.syncPriority4Distribution();
    });
});